<div *ngIf="!isListMode && display">
  <div class="main-d">
    <div class="content-wrapper question-type-fib">
      <div class="btn-wrapper">
        <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
          <span>{{'questions.typeOfQuestions.fillInTheBlanksText.btnBack' | translate}}</span>
        </button>
        <span class="spacer"></span>
        <button [disabled]="form.invalid || isInvalid" mat-flat-button color="" class="btn-primary" aria-label="Save" (click)='saveQuestion()'>
          <span>{{'questions.typeOfQuestions.fillInTheBlanksText.btnSave' | translate}}</span>
        </button>
      </div>

      <div class="filter-section">
        <div class="body-section title">
          <mat-icon>library_add</mat-icon> &nbsp;
          <span>{{'questions.typeOfQuestions.fillInTheBlanksText.title' | translate}}</span>
        </div>
        <form [formGroup]="form">
          <div class="body-section-2" formGroupName="questiondescriptionPreview">
            <button (click)="addBlank()" class="btn-primary" mat-flat-button color="">{{'questions.typeOfQuestions.fillInTheBlanksText.btnAddBlank' |
              translate}}</button>
              <angular-editor id="editor2" formControlName="description" [config]="editorConfig" #fibEditor (ngModelChange)="onChange($event)"
              (click)="onClick(true)"></angular-editor>
              <div *ngIf="isErrorMessage" class="alert alert-danger">{{ errorMessage }}</div>
              <!-- <ckeditor #myEditor formControlName="description" [editor]="Editor" (ready)="onReady($event)"></ckeditor> -->
            <!-- <ckeditor name="question" formControlName="description" data="Enter here..." [config]="ckeditorConfig"
              [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()">
            </ckeditor> -->
          </div>
          <div class="add-option-main">
            <div>
              <div class="input-label">{{'questions.typeOfQuestions.fillInTheBlanksText.labelQuestScore' | translate}}</div>
              <input type="number" min="0" formControlName="correctPoints" class="form-control scoreInput" readonly>
            </div>
            <div class="set-option-containor">
              <div class="input-label" *ngIf="options.length != 0">{{'questions.typeOfQuestions.fillInTheBlanksText.labelSetScore' | translate}}</div>
              <div formArrayName="options">
                <div class="score-wrapper" *ngFor="let o
                  of options.controls; let i= index" [formGroupName]="i">
                  <div class="add-option">
                    <div class="input-class-container">
                      <div class="remove-inputs">
                        <span>{{'questions.typeOfQuestions.fillInTheBlanksText.labelAns' | translate}} {{i+1}}<span class="red-asterisk">*</span></span>
                          <input type="number" formControlName="correctPoints" class="form-control option-number" min="0" max="9999.99" step=".01"
                          (change)="calculateScore();" (input)="validateInput($event, o, 'options')" (keypress)="omit_special_char($event)">
                        <!-- <input min="0"
                          formControlName='correctPoints' class="form-control
                          option-number"
                          type="number" oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"> -->
                        <div class="ansDesc" formGroupName="answerDescription">
                          <input formControlName='description'
                            class="form-control " type="text">
                        </div>
                        <button (click)="removeOption(i+1, o)" mat-flat-button
                          class="btn-warn" color="" [disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true">{{'questions.typeOfQuestions.fillInTheBlanksText.btnRemove' | translate}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div>
            <div>
              <div class="exp-panel">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{'questions.typeOfQuestions.fillInTheBlanksText.accordian.title' | translate}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="container-fluid body-section-2">
                      <div class="row">
                        <div class="col-md-2">
                          <div class="scoring-check">
                            <mat-checkbox formControlName="autoScoring" [disabled]="true"
                              [checked]="true"><b>{{'questions.typeOfQuestions.fillInTheBlanksText.accordian.checkbox' | translate}}</b>
                            </mat-checkbox>
                          </div>
                        </div>
                        <br>
                        <br>
                        <div class="col-md-2">
                          <div class="scoring-check">
                            <div class="invalid-feedback">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-2">
                          <div class="form-label">
                            <label>{{'questions.typeOfQuestions.fillInTheBlanksText.accordian.selectOptions.option1.label' | translate}}</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <mat-form-field class="scoring-type" appearance="fill">
                            <mat-select formControlName="scoringTypeExactMatch">
                              <mat-option [value]="option.id == 1 ? 'true' : 'false'" *ngFor="let option of QuestionScoringType" selected>{{option.title}}</mat-option>

                            </mat-select>
                            <div class="invalid-feedback">
                            </div>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row">
                        <!-- <div class="col-md-2">
                          <label class="form-label score-labels">{{'questions.typeOfQuestions.fillInTheBlanksText.accordian.selectOptions.option2' | translate}}</label>
                        </div>
                        <div class="col-md-3">
                          <input formControlName="penaltyPoints"
                            class="form-control" type="number" min="0">

                        </div>
                        <div *ngIf="!form.get('penaltyPoints').valid &&
                          form.get('penaltyPoints').touched">
                          Required and only zero or positive numbers allowed
                        </div> -->
                        <div class="col-md-2">

                          <label class="form-label score-labels" required>{{'questions.typeOfQuestions.fillInTheBlanksText.accordian.selectOptions.option3.label' | translate}}</label>

                        </div>
                        <div class="col-md-3">
                          <!-- <input formControlName="minScoreIfAttempt" type="number" min="0" max="9999" class="form-control"
                          onkeypress="if(this.value.length == 4 ) return false;"
                          oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"> -->
                          <input type="number" formControlName="minScoreIfAttempt" class="form-control" min="0" max="9999.99" step=".01"
                          (input)="validateInput($event, form.get(reuseProp.minScoreIfAttempt).value, 'minimumScore')" (keypress)="omit_special_char($event)">
                          <div *ngIf="!form.get(reuseProp.minScoreIfAttempt).valid &&
                            (form.get(reuseProp.minScoreIfAttempt).touched || form.get(reuseProp.minScoreIfAttempt).dirty)" class="alert alert-danger zero">
                            {{'questions.typeOfQuestions.fillInTheBlanksText.accordian.selectOptions.option3.errorMsg1' | translate}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isListMode">
  <app-question-list></app-question-list>
</div>
<div *ngIf="!display">
  <app-choose-question-type></app-choose-question-type>
</div>
